import cx from 'classnames';

type Props = {
    children: React.ReactNode;
    className?: string;
    onClick?: () => void;
}

export const Square: React.FC<Props> = ({children, className, onClick}: Props) => (
    <div className={cx('tw-relative tw-w-full', className)} style={{paddingBottom: '100%'}} onClick={onClick}>
        <div className='tw-absolute tw-inset-0'>
            {children}
        </div>
    </div>
);
